import React, { useEffect, useState } from "react";
import "../../../styles/trainer/trainer.css";
import { trainersV2Get } from "../../../data/ApiEndpoints";
import { useSelector } from "react-redux";
import { selectToken } from "../../auth/auth.selector";
import { BASE_URL } from "../../../data/BaseUrl";
import Loader from "../../ui/Loader";
import { Button } from "react-bootstrap";
import { addDays, format } from "date-fns";
import DateRanger from "../../components-react/DateRanger";
import moment from "moment";
import {
  convertStraight,
  currentMonthCurrentDate,
  currentMonthStartDate,
} from "../../common-data/Converts";

const AttendanceHistory = ({ queryParametersForAll }) => {
  const token = useSelector(selectToken);
  const [attendanceData, setAttendanceData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dateRangerOpen, setDateRangerOpen] = useState(false);
  const initalStartandenddateValues = {
    startDate: currentMonthStartDate || "",
    endDate: currentMonthCurrentDate || "",
    selectedDates:
      `${convertStraight(currentMonthStartDate)} to ${convertStraight(
        currentMonthCurrentDate
      )}` || "",
  };
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);
  const [startAndEndDate, setStartAndEndDate] = useState(
    initalStartandenddateValues
  );

  const urlSearchParams = new URLSearchParams(queryParametersForAll);
  const trainerIdQueryParam = urlSearchParams.get("trainer_id");

  const handleDateRangeChange = (item, name) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    const formattedStart = moment(formattedStartDate).tz("Asia/Kolkata").format("DD-MM-YYYY");
    const formattedEnd = moment(formattedEndDate).tz("Asia/Kolkata").format("DD-MM-YYYY");

    setStartAndEndDate({
      ...startAndEndDate,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      selectedDates: `${formattedStart} to ${formattedEnd}`,
    });
  };

  async function getAttendance() {
    try {
      setIsLoading(true);
      const res = await fetch(
        `${BASE_URL}${trainersV2Get}?limit=1&trainer_id=${trainerIdQueryParam}&start_date=${startAndEndDate.startDate}&end_date=${startAndEndDate.endDate}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      const tData = transformApiResponse(data);

      tData.sort((a, b) => {
        const dateA = new Date(a.date.split("-").reverse().join("-"));
        const dateB = new Date(b.date.split("-").reverse().join("-"));
        return dateA - dateB;
      });

      setAttendanceData(tData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  function transformApiResponse(apiResponse) {
    try {
      if (apiResponse) {
        const res = apiResponse.data?.[0]?.shift_details?.map((trainer) => ({
          date: trainer.date || "-",
          shift_details: [
            {
              shift_name: "Morning",

              in_time: {
                time:
                  trainer?.shift_name === "Morning" &&
                  trainer?.checkin_details?.map((shift) =>
                    shift?.mode === "in" && shift?.time
                      ? moment(shift.time, "HH:mm:ss").tz("Asia/Kolkata").format("hh:mm A")
                      : ""
                  ),
              },

              out_time: {
                time:
                  trainer?.shift_name === "Morning" &&
                  trainer?.checkin_details?.map((shift) =>
                    shift?.mode === "out" && shift?.time
                      ? moment(shift.time, "HH:mm:ss").tz("Asia/Kolkata").format("hh:mm A")
                      : ""
                  ),
              },

              working_hours:
                trainer?.shift_name === "Morning" &&
                (trainer?.start_time || trainer?.end_time)
                  ? `${moment(trainer?.start_time, "HH:mm:ss").tz("Asia/Kolkata").format(
                      "hh:mm A"
                    )}-${moment(trainer?.end_time, "HH:mm:ss").tz("Asia/Kolkata").format(
                      "hh:mm A"
                    )}`
                  : "-",
            },
            {
              shift_name: "Evening",

              in_time: {
                time:
                  trainer?.shift_name === "Evening" &&
                  trainer?.checkin_details?.map((shift) =>
                    shift?.mode === "in" && shift?.time
                      ? moment(shift.time, "HH:mm:ss").tz("Asia/Kolkata").format("hh:mm A")
                      : ""
                  ),
              },

              out_time: {
                time:
                  trainer?.shift_name === "Evening" &&
                  trainer?.checkin_details?.map((shift) =>
                    shift?.mode === "out" && shift?.time
                      ? moment(shift.time, "HH:mm:ss").tz("Asia/Kolkata").format("hh:mm A")
                      : ""
                  ),
              },

              working_hours:
                trainer?.shift_name === "Evening" &&
                (trainer?.start_time || trainer?.end_time)
                  ? `${moment(trainer?.start_time, "HH:mm:ss").format(
                      "hh:mm A"
                    )}-${moment(trainer?.end_time, "HH:mm:ss").format(
                      "hh:mm A"
                    )}`
                  : "-",
            },
          ],
        }));

        // const res = apiResponse.data.map((trainer) => ({
        //   date: trainer.date_onboarding,
        //   shift_details: trainer.shift_details.map((shift) => ({
        //     shift_name: shift.shift_name,
        //     working_hours: `${shift.start_time}-${shift.end_time}`,
        //     in_time: {
        //       time: shift.checkin_details[0]?.time2 || "N/A",
        //     },
        //     out_time: {
        //       time: shift.checkin_details[1]?.time2 || "N/A",
        //     },
        //   })),

        return res;
      } else {
        return [];
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    try {
      getAttendance();
    } catch (error) {
      console.log(error);
    }
  }, [trainerIdQueryParam]);

  useEffect(() => {
    try {
      getAttendance();
    } catch (error) {
      console.log(error);
    }
  }, [startAndEndDate]);

  function loader() {
    try {
      if (isLoading) {
        return true;
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div>
      <header className="flex-k items-center-k js-between-k mt30">
        <h4>Attendance History</h4>
        <div className="flex-k gap-5 items-center-k">
          <div>
            {dateRangerOpen ? (
              <div className="flex-k js-center-k closeAndClearDateRangerButtons">
                <Button
                  variant="primary"
                  onClick={() => setDateRangerOpen(false)}
                >
                  Close
                </Button>
                <Button
                  variant="danger"
                  onClick={() => {
                    setDateRangerOpen(false);
                    setRangeState(initialRangeState);
                    setStartAndEndDate({
                      ...startAndEndDate,
                      startDate: "",
                      endDate: "",
                      selectedDates: "",
                    });
                  }}
                >
                  Clear
                </Button>
              </div>
            ) : startAndEndDate?.selectedDates ? (
              <button
                onClick={() => {
                  setDateRangerOpen(true);
                }}
                className="btn-k btn-muted-k small"
              >
                {startAndEndDate.selectedDates}
              </button>
            ) : (
              <button
                onClick={() => {
                  setDateRangerOpen(true);
                }}
                className="btn-k btn-muted-k small"
              >
                Select Date
              </button>
            )}
          </div>
          {/* <button
            className="btn-k rounded-full-k btn-muted-k small"
            onClick={onClose}
          >
            <RxCross1 size={25} />
          </button> */}
        </div>
      </header>

      {dateRangerOpen && (
        <div className="openedDateRanger dateCommonWrapper">
          <DateRanger
            handleDateRangeChange={handleDateRangeChange}
            rangeState={rangeState}
            onClose={() => setDateRangerOpen(false)}
            onClear={() => {
              setDateRangerOpen(false);
              setRangeState(initialRangeState);
              setStartAndEndDate(null);
            }}
          />
        </div>
      )}
      {loader() ? (
        <Loader />
      ) : (
        <div className="attendance-history-box">
          <div className="attendance-history-header">
            <div>
              <span className="bold-text">Date</span>
            </div>
            <div>
              <span className="bold-text">Shift</span>
            </div>
            <div>
              <span className="bold-text">Working Hours</span>
            </div>
            <div>
              <span className="bold-text">In Time</span>
            </div>
            <div>
              <span className="bold-text">Out Time</span>
            </div>
          </div>
          <div>
            {attendanceData &&
              attendanceData?.map((shift, i) => (
                <div className="attendance-history-row" key={i}>
                  <div className="flex-k js-center-k items-center-k">
                    <span>{shift?.date}</span>
                  </div>
                  <div className="flex-k flex-col-k border">
                    {shift?.shift_details?.map((shift, index) => (
                      <div
                        className="attendance-history-shift"
                        key={`${i}[${index}]`}
                      >
                        <div className="flex-k flex-col-k">
                          <span>{shift?.shift_name}</span>
                        </div>
                        <div className="flex-k flex-col-k">
                          <span>{shift?.working_hours}</span>
                        </div>
                        <div className="flex-k flex-col-k">
                          <span>{shift?.in_time?.time}</span>
                          <span>{shift?.in_time?.tag}</span>
                        </div>
                        <div className="flex-k flex-col-k">
                          <span>{shift?.out_time?.time}</span>
                          <span>{shift?.out_time?.tag}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AttendanceHistory;
